import { Component, AfterViewInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  ValidatorFn,
  Validators,
} from '@angular/forms';

import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';

import { MatDialog } from '@angular/material/dialog';

import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';

import { MY_DATE_FORMATS } from '../../utils/date-format';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { AutorizacionesService } from '../../services/mis-autorizaciones/misautorizaciones.service';
import { AutorizacionTabla } from '../../models/autorizaciones/AutorizacionesTabla';
import { AutorizacionesRequest } from '../../models/autorizaciones/AutorizacionesRequest';

import moment, { Moment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort } from '@angular/material/sort';
import { ModalBitacoraComponent } from './modal-bitacora.component';
import { MatPaginator } from '@angular/material/paginator';
import { ModalReenvioComponent } from './modal-reenvio-soportes.component';
import { ModalConfirReenvioComponent } from './modal-confir-reenvio-soportes.component';
import { AuthService } from '../../services/security/auth.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';

@Component({
  selector: 'app-autorizaciones',
  templateUrl: './autorizaciones.component.html',
  styleUrls: ['./autorizaciones.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AutorizacionesComponent extends Base implements AfterViewInit {


  frmAutorizaciones: FormGroup;

  tiposDoc = [
    { codigo: 'BG', label: 'BG - BEBE GESTANTE' },
    { codigo: 'CC', label: 'CC - CEDULA DE CIUDADANÍA' },
    { codigo: 'CE', label: 'CE - CEDULA DE EXTRANJERÍA' },
    { codigo: 'CN', label: 'CN - NACIDO VIVO' },
    { codigo: 'PA', label: 'PA - PASAPORTE' },
    { codigo: 'PE', label: 'PE - PERMISO ESPECIAL DE PERMANENCIA' },
    { codigo: 'PT', label: 'PT - PERMISO POR PROTECCIÓN TEMPORAL' },
    { codigo: 'RC', label: 'RC - REGISTRO CIVIL DE NACIMIENTO' },
    { codigo: 'TI', label: 'TI - TARJETA DE IDENTIDAD' },
  ];
  estados = [
    { label: 'Finalizada', value: 'FINALIZADA' },
    { label: 'En trámite', value: 'EN TRAMITE' },
    { label: 'Radicado', value: 'RADICADO' },
    { label: 'Soportes incompletos', value: 'SOPORTES INCOMPLETOS' }
  ];

  today: Date = new Date();
  minFechaRadicacion: Date = new Date();
  maxFechaRadicacion: Date = new Date();
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isLoading = false;
  cedulaAsesorLogueado: string = '';


  dsAutorizaciones = new MatTableDataSource<any>();

  displayedColumns: string[] = [
    'fecha',
    'radicado',
    'estado',
    'tipoDoc',
    'numDoc',
    'nombre',
    'ciudad',
    'celular',
    'email',
    'acciones',
  ];


  haveResponse = false;
  haveDataToShow = false;
  generalMessage = '';
  logInfo: any;
  cedulaAsesor: any;
  loggedUser: any;
  nombre_Asesor: any;
  trackDataConsulta!: TrackData;
  trackDataReenvio: TrackData = {
    module: 'Autorizaciones',
    category: 'N/A',
    submodule: 'Seguimiento autorizaciones',
    functionality: 'Reenviar soportes médicos',
    cedulaAsesor: '',
    fechaInteraccion: '',
    nombreAsesor: '',
    identificadorInteraccion: 'AU_REENVIO_AU_REENVIAR'
  };

  constructor(
    private fb: FormBuilder,
    private mainCmp: MaincontainerComponent,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private autorizacionesService: AutorizacionesService,
    private authService: AuthService,
    private trackingService: TrackingService, 
  ) {
    super();

    this.frmAutorizaciones = this.fb.group({
      tipoDoc: [''],
      numDoc: ['', [Validators.maxLength(20), this.noSpacesValidator()]],
      numSolicitud: [''],
      estado: [''],
      fechaInicio: [null],
      fechaFin: [null],
    },
      { validators: this.filtroAutorizacionesValidator() }
    );

    this.minFechaRadicacion.setMonth(this.today.getMonth() - 6);
    this.maxFechaRadicacion = new Date();
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmAutorizaciones.controls;
  }


  async ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA AUTORIZACIONES');
      console.log('SORT:', this.sort);
    });

    this.cedulaAsesorLogueado = this.mainCmp.cedulaAsesor;

    console.log('Autorizaciones → Asesor logueado:', this.cedulaAsesorLogueado);

    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    console.log('userCC:', this.cedulaAsesor);

    this.trackDataConsulta = {
      module: 'Autorizaciones',
      category: 'N/A',
      submodule: 'Seguimiento autorizaciones',
      functionality: 'Consultar',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'AU_SEGUIMIENTO_AU_CONSULTAR'
    };

    this.trackDataReenvio.cedulaAsesor = this.cedulaAsesor;
    this.trackDataReenvio.nombreAsesor = this.nombre_Asesor;
    this.trackDataReenvio.fechaInteraccion = this.getCurrentTimestamp();
  }



  consultar(): void {
    this.isLoading = true;
    this.generalMessage = '';
    this.haveResponse = true;
    this.haveDataToShow = false;

    const form = this.frmAutorizaciones.value;

    const hoy = moment();

    let fecInic = hoy.clone().subtract(1, 'year');
    let fecFin = hoy;

    if (this.frmAutorizaciones.invalid) {
      this.generalMessage = 'Debe ingresar los campos obligatorios para la consulta.';
      this.frmAutorizaciones.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.spinner.show();


    if (form.fechaInicio && moment(form.fechaInicio).isValid()) {
      fecInic = moment(form.fechaInicio);
    }

    if (form.fechaFin && moment(form.fechaFin).isValid()) {
      fecFin = moment(form.fechaFin);
    }

    const request: AutorizacionesRequest = {
      TipoDoc: form.tipoDoc || null,

      pNumDoc: form.numDoc || null,

      pNumSol: form.numSolicitud || null,

      pFecInic: fecInic.format('YYYY-MM-DD'),
      pFecFin: fecFin.format('YYYY-MM-DD'),
      estadoSolic: form.estado || null,
    };

    this.autorizacionesService.consultarAutorizaciones(request).subscribe({
      next: (resp) => {

        console.log('DATA TABLA => ', resp.data);

        this.spinner.hide();

        this.isLoading = false;

        console.log('RESPUESTA BACKEND COMPLETA:', resp);
        console.log('DATA:', resp.data);
        if (resp.data && resp.data.length > 0) {

          const asesorServicio = resp.data[0].numeroDocumentoAsesor?.trim();
          const asesorLogueado = this.mainCmp.cedulaAsesor?.trim();

          console.log('Asesor servicio:', asesorServicio);
          console.log('Asesor logueado:', asesorLogueado);

          if (asesorServicio !== asesorLogueado) {
            this.dsAutorizaciones.data = [];
            this.haveDataToShow = false;
            this.generalMessage =
              'El usuario consultado no pertenece a su población.';
            return;
          }

          const mapped = resp.data.map((item) => ({
            fecha: item.fecregistro,
            radicado: item.codsolicitud,
            estado: item.estadosolic,
            tipoDoc: item.tipoDocumentoUsuario,
            numDoc: item.numeroDocumentoUsuario,
            nombre: item.nombre_Usuario,
            ciudad: item.nombreciudad,
            celular: item.celular,
            email: item.email,
            obsSolicFin: item.feccierre,
          }));

          this.haveDataToShow = mapped.length > 0;

          if (!this.haveDataToShow) {
            this.generalMessage =
              'No se encontraron resultados con los datos ingresados.';
          }

          this.dsAutorizaciones.data = mapped;
          this.haveDataToShow = mapped.length > 0;

          setTimeout(() => {
            this.dsAutorizaciones.sort = this.sort;
            this.dsAutorizaciones.paginator = this.paginator;
          });

          this.dsAutorizaciones.sortingDataAccessor = (item: any, property: string) => {
            switch (property) {
              case 'fecha':
                return new Date(item.fecha).getTime();
              case 'radicado':
                return Number(item.radicado);
              case 'estado':
                return item.estado || '';
              default:
                return (item[property] || '').toString().toLowerCase();
            }
          };

          this.dsAutorizaciones.data = mapped;
          //this.haveDataToShow = mapped.length > 0;
          setTimeout(() => {
            this.dsAutorizaciones.sort = this.sort;
          });

          if (!this.haveDataToShow) {
            this.generalMessage =
              'No se encontraron resultados con los datos ingresados.';
          }
        } else {
          this.generalMessage =
            resp.errorMessage || 'No se encontraron resultados para la solicitud ingresada.';
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.isLoading = false;
        console.error(err);
        this.generalMessage = 'Error de comunicación con el servidor.';
      },
    });
  }

  limpiar(): void {
    this.frmAutorizaciones.reset();
    this.dsAutorizaciones.data = [];
    this.haveDataToShow = false;
    this.haveResponse = false;
    this.generalMessage = '';
  }

  abrirBitacora(row: any): void {

    const dialogRef = this.dialog.open(ModalBitacoraComponent, {
      width: '900px',
      maxHeight: '80vh',
      panelClass: 'bitacora-dialog',
      disableClose: true,
      data: {
        loading: true,
        sinDatos: false,
        fechaRadicacion: row.fecha,
        numeroSolicitud: row.radicado,
        gestiones: []
      }
    });

    const request = {
      p_id_solicitud: row.radicado
    };

    this.autorizacionesService.getBitacoraSolicitud(request).subscribe({
      next: (resp) => {

        console.log('RESP BITÁCORA:', resp);

        if (resp.data && resp.data.length > 0) {
          dialogRef.componentInstance.data.loading = false;
          dialogRef.componentInstance.data.gestiones = resp.data;
        } else {
          dialogRef.componentInstance.data.loading = false;
          dialogRef.componentInstance.data.gestiones = [];
          dialogRef.componentInstance.data.sinDatos = true;
        }
      },
      error: (err) => {
        console.error(err);
        dialogRef.close();
        this.generalMessage = 'Error consultando la bitácora.';
      }
    });
  }



  onChangeFechaRadicacion(event: MatDatepickerInputEvent<Date>) {
    const selectedDate = event.value ? moment(event.value) : null;
    this.frmAutorizaciones.get('fechaRadicacion')?.setValue(selectedDate);
  }

  override hasError(control: AbstractControl | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  override printError(
    control: AbstractControl | null,
    customMessages?: { [key: string]: string }
  ): string {
    if (!control || !control.errors) return '';

    const errors = control.errors;
    const messages: { [key: string]: string } = {
      required: 'Este campo es obligatorio.',
      maxlength: 'Longitud máxima excedida.',
      noSpaces: 'No se permite espacios.',
      matDatepickerParse: 'Fecha inválida. Usa el formato YYYY/MM/DD.',
      ...customMessages,
    };

    const firstErrorKey = Object.keys(errors)[0];
    return messages[firstErrorKey] || 'Error desconocido.';
  }

  filtroAutorizacionesValidator(): ValidatorFn {
    return (group: AbstractControl) => {
      const tipoDoc = group.get('tipoDoc')?.value;
      const numDoc = group.get('numDoc')?.value;
      const numSolicitud = group.get('numSolicitud')?.value;

      const tieneDocCompleto = tipoDoc && numDoc;
      const tieneSolicitud = numSolicitud;

      if (tieneDocCompleto || tieneSolicitud) {
        return null;
      }

      return { filtroInvalido: true };
    };
  }

  confirmarReenvio(row: any) {

    const email = row.email;
    const correoEnmascarado = this.maskEmail(email);

    const dialogRef = this.dialog.open(ModalReenvioComponent, {
      width: '450px',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      panelClass: 'reenvio-dialog',
      data: {
        email,
        correoEnmascarado,
        radicado: row.radicado
      }
    });

    dialogRef.afterClosed().subscribe(confirmado => {
      if (confirmado) {
        this.reenviarSoportes(row);
      }
    });
  }

  maskEmail(email: string): string {
    if (!email) return '';

    const [user, domain] = email.split('@');
    if (user.length <= 2) return `**@${domain}`;

    return `${user[0]}****${user[user.length - 1]}@${domain}`;
  }

  reenviarSoportes(row: any) {

    const request = {
      p_id_solicitud: row.radicado,
      email: row.email
    };

    console.log('REENVÍO SOPORTES - REQUEST:', request);

    this.autorizacionesService.reenviarSoportes(request).subscribe({
      next: () => {
        this.dialog.open(ModalConfirReenvioComponent, {
          width: '400px',
          autoFocus: false,
          restoreFocus: false,
          panelClass: 'confirm-reenvio-dialog',
          data: {
            mensaje: 'Se enviaron los soportes al correo correctamente.'
          }
        });
      },
      error: () => {
        this.dialog.open(ModalConfirReenvioComponent, {
          width: '400px',
          panelClass: 'confirm-reenvio-dialog',
          data: {
            mensaje: 'Ocurrió un error enviando los soportes.'
          }
        });
      }
    });
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  noSpacesValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const hasSpaces = /\s/.test(control.value);
      return hasSpaces ? { noSpaces: true } : null;
    };
  }
}
